import React from 'react';

const SearchHero = React.memo(({ searchQuery, setSearchQuery }) => (
  <section className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden mb-6">
    {/* Background image with overlay text */}
    <div className="relative">
      <img
        src="https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=1400"
        alt=""
        className="w-full h-40 sm:h-48 object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/50" />
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-white drop-shadow-sm">
          Discover Amazing Places in Pakistan
        </h1>
        <p className="text-white/85 text-sm sm:text-base mt-1.5">
          Explore resorts, tourist spots &amp; hidden gems
        </p>
      </div>
    </div>

    {/* Search bar row */}
    <div className="p-3 sm:p-4 bg-white">
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="flex-1 flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5">
          <svg className="w-4 h-4 text-gray-400 shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
          </svg>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search place name..."
            className="w-full bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400"
          />
        </div>

        <button
          type="button"
          className="flex items-center justify-between rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-600 hover:border-gray-300 transition-colors sm:w-36"
        >
          Filter by city
          <svg className="w-4 h-4 text-gray-400 ml-1" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
        </button>

        <button
          type="button"
          className="flex items-center justify-between rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-600 hover:border-gray-300 transition-colors sm:w-36"
        >
          Points Listing
          <svg className="w-4 h-4 text-gray-400 ml-1" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
        </button>

        <button
          type="button"
          className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-emerald-700 text-white px-5 py-2.5 text-sm font-medium hover:bg-emerald-800 transition-colors shadow-sm"
        >
          Search
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </button>
      </div>
    </div>
  </section>
));

SearchHero.displayName = 'SearchHero';

export default SearchHero;
